<template>
  <div class="main flex_column">

    <IifeUser :swiperList="advertSwiper" />

    <div class="life-menu">
      <Menu :list="menuList" @click="menuClick" :authToken="authToken" />
    </div>

    <div class="life-advert">
      <MySwiper :swipers="swipers" radius="9px" :dotShow="false" />
    </div>

    <LifeNavBar :authToken="authToken" />

    <!-- <div class="">
      <myswiper :swipers="swipers"></myswiper>
    </div> -->

    <!-- <grid></grid> -->

    <!-- <el-container>
      <paymentlist></paymentlist>

      <el-main>
        <notice></notice>
      </el-main>

      <el-footer>
        Developed by 龍科技
      </el-footer>
    </el-container> -->
  </div>
</template>
<script>
  import MySwiper from '@/components/swiper.vue';
  // import paymentlist from '@/components/paymentlist.vue';
  import grid from '@/components/grid.vue';
  import notice from '@/components/notice.vue';
  import IifeUser from '@/components/lifeUser.vue';
  import Menu from '@/components/menu.vue';
  import LifeNavBar from '@/components/lifeNavBar.vue';

  export default {
    name: 'lifepay',
    // 组件注册
    components: {
      // paymentlist,
      MySwiper,
      grid,
      notice,
      IifeUser,
      Menu,
      LifeNavBar
    },
    data() {
      return {
        swipers: [],
        rechargeList: [
          { type: 'water', isLife: 1, title: '水费', pageTitle: '水费缴费', src: require('../../static/images/lifePay/menu/shuifei.png') },
          { type: 'electric', isLife: 1, title: '电费', pageTitle: '电费缴费', src: require('../../static/images/lifePay/menu/dianfei.png') },
          { type: 'net', isLife: 1, title: '网费', pageTitle: '网费缴费', src: require('../../static/images/lifePay/menu/wangfei.png') },
          { type: 'transpotoll', isLife: 1, title: '高速', pageTitle: '高速缴费', src: require('../../static/images/lifePay/menu/gaosu.png') },
          { type: 'esim', isLife: 1, title: 'ESIM', pageTitle: 'ESIM', src: require('../../static/images/lifePay/menu/esim.png') },
          // { type: 'Grab', isLife: 2, title: 'Grab', pageTitle: 'Grab App充值', src: require('../../static/images/lifePay/menu/grab.png') },
          // { type: 'GCASH', isLife: 2, title: 'GCASH', pageTitle: 'GCASH钱包充值', src: require('../../static/images/lifePay/menu/GCASH.png') },
          // { type: 'ShopeePay', isLife: 2, title: 'ShopeePay', pageTitle: 'ShopeePay充值', src: require('../../static/images/lifePay/menu/ShopeePay.png') },
          // { type: 'LazadaPay', isLife: 2, title: 'LazadaPay', pageTitle: 'Lazada钱包充值', src: require('../../static/images/lifePay/menu/LazadaPay.png') },
        ],
        advertSwiper: []
      }
    },
    computed: {
      authToken() {
        return localStorage.getItem('auth_token')
      },
      menuList() {
      	return this.$store.state.rechargeCategory
      }
    },
    created() {
      this.getLifeBanner()
    },
    methods: {
      // 获取生活缴费banner
      async getLifeBanner() {
        const { data } = await this.$api.request('System/banners', {
           position: 1,
           location: ''
        })
        this.advertSwiper = data[0]
        this.swipers = data[1]
      },
      menuClick(item) {
        // console.log(item)
        this.$store.commit('setIsLife', 1)
        this.$router.push({
          path: '/placeOrder',
          query: { id: item.id }
        })
      }
    }
  }
</script>
<style scoped>
  .el-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
  }

  .life-menu {
    margin-top: 11px;
    /* padding: 0 24px; */
    padding: 0 16px;
  }

  .life-advert {
    padding: 0 24px;
    margin-top: 35px;
    margin-bottom: 80px;
  }
</style>
<style>
  .life-advert .swiper-container {
    padding-bottom: 13px;
  }
  .swiper-pagination-fraction, .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 0 !important;
  }
  .swiper-pagination {
    text-align: right !important;
  }
  .swiper-pagination-bullet-active {
    background: #FF0000 !important;
  }
  .swiper-pagination-bullet {
    width: 7px;
    height: 7px;
    background: #C4C4C4;
  }
</style>



// WEBPACK FOOTER //
// src/page/lifepay.vue